export default __webpack_public_path__ + "static/april700k-5debe6c414e715b21962047fc6eb9de9.mp4";